import { Paper, Typography, Button, Stack, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { vendorNav } from './VendorBids';

export default function BidConfirmation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const reference = state?.reference;
  const tenderTitle = state?.tenderTitle;
  const resubmitted = state?.resubmitted;
  const timestamp = new Date().toLocaleString('en-GB');

  return (
    <DashboardLayout nav={vendorNav}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Paper sx={{ p: 5, maxWidth: 520, textAlign: 'center' }}>
          <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom>{resubmitted ? 'Your bid has been updated.' : 'Your bid has been successfully submitted.'}</Typography>
          {tenderTitle && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{tenderTitle}</Typography>}

          <Box sx={{ my: 3 }}>
            <Typography variant="caption" color="text.secondary" display="block">Bid Reference Number</Typography>
            <Typography variant="h6" color="primary">{reference || '—'}</Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 2 }}>Timestamp</Typography>
            <Typography variant="body2">{timestamp}</Typography>
          </Box>

          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="outlined" onClick={() => window.print()}>Download Receipt</Button>
            <Button variant="contained" onClick={() => navigate('/vendor/bids')}>Back to My Bids</Button>
          </Stack>
        </Paper>
      </Box>
    </DashboardLayout>
  );
}
